import React from "react";

import Routes from "./routes";

import Global from "./styles/global";

function App() {
  return (
    <>
      <Routes />

      <Global />
    </>
  );
}

export default App;
